// Translation: Password change > Landing > Form (Arabic)
export default Object.freeze({
	form: {
		actions: {
			changePassword: ''
		},
		fields: {
			oldPassword: {
				placeholder: ''
			},
			password: {
				placeholder: ''
			},
			passwordConfirmation: {
				placeholder: ''
			}
		},
		title: ''
	}
})
